/**
 * 비밀번호 재설정 폼: Form.ts로 AJAX 제출 (fetch, loading, try/catch).
 * 성공 시 메시지 알림 후 로그인으로 redirect, 실패 시 에러 박스에 표시.
 * Form must have id="auth-reset-password-form" and data-submit-url.
 */

import { Form } from "../../core/Form";
import { Modal } from "../../utils/Modal";

const FORM_ID = "auth-reset-password-form";
const ERROR_BOX_ID = "auth-reset-password-error";

function getErrorBox(): HTMLElement | null {
  return document.getElementById(ERROR_BOX_ID);
}

function showError(message: string | null): void {
  const box = getErrorBox();
  if (!box) return;
  if (message === null || message === "") {
    box.innerHTML = "";
    box.hidden = true;
    return;
  }
  box.textContent = message;
  box.hidden = false;
}

function getFirstError(errors: Record<string, string[]> | undefined): string {
  if (!errors || typeof errors !== "object") return "";
  const first = Object.values(errors).flat()[0];
  return typeof first === "string" ? first : "";
}

export function initAuthResetPasswordForm(): void {
  const form = document.getElementById(FORM_ID) as HTMLFormElement | null;
  if (!form) return;

  const submitUrl = form.dataset.submitUrl ?? form.action;
  if (!submitUrl) return;

  new Form(form, {
    submitUrl,
    submitButtonSelector: "button[type=submit]",
    loaderSelector: ".auth-page__btn-loader",
    requestFailedMessage: document.documentElement.lang?.startsWith("ko")
      ? "요청을 보낼 수 없습니다."
      : "Request failed.",
    invalidResponseMessage: document.documentElement.lang?.startsWith("ko")
      ? "응답을 처리할 수 없습니다."
      : "Invalid response.",
    onSuccess: async (data) => {
      const msg = (data?.message ?? data?.msg ?? "") as string;
      const redirect = (data?.data as { redirect?: string } | undefined)?.redirect;
      if (msg) {
        await Modal.alert(msg);
      }
      if (redirect) {
        window.location.href = redirect;
      }
    },
    onFail: (message, data) => {
      const errors = data?.errors as Record<string, string[]> | undefined;
      const first = getFirstError(errors);
      showError(first || message || "");
    },
  }).init();

  form.addEventListener("submit", () => showError(null));
}
